import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Poppins, from src/assets/fonts — bundled with the app, nothing fetched from a font CDN.
import './assets/fonts/poppins.css';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
